// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.asu__stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}
.asu__stat-card {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.asu__stat-top {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}
.asu__stat-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.asu__stat-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--admin-muted);
  margin: 0;
}
.asu__stat-value {
  font-family: var(--font-body);
  font-size: 2rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
  line-height: 1;
}
.asu__stat-change {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.75rem;
  font-weight: 500;
  margin: 0;
}
.asu__stat-change.up {
  color: var(--admin-green);
}
.asu__stat-change.down {
  color: var(--admin-red);
}

.asu__layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}
.asu__layout--detail {
  grid-template-columns: 1fr 320px;
  align-items: start;
}

.asu__filters {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}
.asu__search-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 180px;
}
.asu__search-icon {
  position: absolute;
  left: 0.75rem;
  font-size: 0.9rem;
  color: var(--admin-muted);
  pointer-events: none;
}
.asu__search {
  width: 100%;
  padding: 0.6rem 0.9rem 0.6rem 2.25rem;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  background: #fff;
  font-size: 0.84rem;
  color: var(--admin-text);
  outline: none;
}
.asu__search:focus {
  border-color: var(--admin-rust);
}
.asu__date-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.9rem;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  background: #fff;
  font-size: 0.84rem;
  color: var(--admin-text);
  white-space: nowrap;
  cursor: pointer;
}
.asu__filters-right {
  margin-left: auto;
}

.asu__table-card {
  padding: 0;
  overflow: hidden;
}
.asu__table {
  width: 100%;
  border-collapse: collapse;
}
.asu__table th {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--admin-muted);
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--admin-border);
  text-align: left;
  background: #fafaf8;
}
.asu__table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f0ebe4;
  vertical-align: middle;
}
.asu__table tbody tr:last-child td {
  border-bottom: none;
}
.asu__th-check {
  width: 2.5rem;
}
.asu__email-cell {
  font-size: 0.84rem;
  font-weight: 500;
  color: var(--admin-text);
}
.asu__source-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  color: var(--admin-text);
}

.asu__badge--active {
  background: rgba(22, 163, 74, 0.1);
  color: var(--admin-green);
  border-radius: 99px;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.2rem 0.6rem;
}
.asu__badge--unsub {
  background: rgba(107, 98, 88, 0.1);
  color: var(--admin-muted);
  border-radius: 99px;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.2rem 0.6rem;
}

/* Detail */
.asu__detail {
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 10px;
  overflow: hidden;
  position: sticky;
  top: calc(var(--admin-topbar-h)+1rem);
}
.asu__detail-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid var(--admin-border);
}
.asu__detail-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}
.asu__detail-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  color: var(--admin-muted);
  padding: 0.2rem;
  border-radius: 4px;
}
.asu__detail-close:hover {
  background: #f3f4f0;
}
.asu__detail-user {
  display: flex;
  gap: 0.85rem;
  padding: 1rem;
  align-items: flex-start;
}
.asu__detail-avatar {
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.asu__detail-name {
  font-size: 1rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.15rem;
}
.asu__detail-email {
  font-size: 0.78rem;
  color: var(--admin-muted);
  margin: 0 0 0.4rem;
}
.asu__detail-info {
  padding: 0 1rem 1rem;
  border-bottom: 1px solid var(--admin-border);
}
.asu__detail-info-text {
  font-size: 0.78rem;
  color: var(--admin-muted);
  margin: 0 0 0.75rem;
}
.asu__detail-source {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.asu__detail-source-label {
  font-size: 0.78rem;
  color: var(--admin-muted);
}
.asu__source-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  background: rgba(var(--admin-rust-rgb), 0.08);
  color: var(--admin-rust);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.2rem 0.65rem;
  border-radius: 99px;
}
.asu__detail-section {
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--admin-border);
}
.asu__detail-section:last-child {
  border-bottom: none;
}
.asu__detail-section-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.65rem;
}
.asu__activity-item {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.4rem 0;
}
.asu__activity-icon {
  width: 1.8rem;
  height: 1.8rem;
  background: rgba(var(--admin-rust-rgb), 0.08);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  color: var(--admin-rust);
  flex-shrink: 0;
}
.asu__activity-label {
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--admin-text);
  margin: 0;
}
.asu__activity-time {
  font-size: 0.7rem;
  color: var(--admin-muted);
  margin: 0;
}
.asu__action-full {
  width: 100%;
  margin-bottom: 0.5rem;
}
.asu__unsub-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.65rem;
  border: 1px solid var(--admin-rust);
  border-radius: 6px;
  background: transparent;
  color: var(--admin-rust);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 0.5rem;
  transition: background 0.15s;
}
.asu__unsub-btn:hover {
  background: rgba(var(--admin-rust-rgb), 0.06);
}
.asu__delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.65rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--admin-red);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 0.5rem;
  transition: background 0.15s;
}
.asu__delete-btn:hover {
  background: rgba(220, 38, 38, 0.06);
}
.asu__delete-warn {
  font-size: 0.72rem;
  color: var(--admin-muted);
  margin: 0;
  background: #faf7f2;
  border-radius: 6px;
  padding: 0.6rem 0.75rem;
}

@media (max-width: 1199px) {
  .asu__stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .asu__layout--detail {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 767px) {
  .asu__stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Row context menu */
.asu__row-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  z-index: 50;
  min-width: 160px;
  overflow: hidden;
}
.asu__row-menu button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.6rem 0.9rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.82rem;
  color: var(--admin-text);
  text-align: left;
  transition: background 0.12s;
}
.asu__row-menu button:hover { background: #f9f7f3; }
.asu__row-menu-divider { height: 1px; background: var(--admin-border); }
.asu__row-menu-delete { color: var(--admin-red) !important; }

/* Date filter */
.asu__date-filter {
  display: flex; align-items: center; gap: 0.5rem;
  padding: 0.6rem 0.9rem; border: 1px solid var(--admin-border);
  border-radius: 8px; background: #fff; font-size: 0.84rem;
  color: var(--admin-text); cursor: pointer; white-space: nowrap;
}

/* toast + bulk bar (also defined in AdminApplications.css — import from there if shared) */
.ann__toast {
  display: flex; align-items: center; gap: 0.5rem;
  background: rgba(22,163,74,0.1); border: 1px solid rgba(22,163,74,0.3);
  border-radius: 8px; padding: 0.65rem 1rem;
  font-size: 0.84rem; font-weight: 600; color: #16a34a;
  animation: slideDown 0.25s ease;
}
@keyframes slideDown {
  from { opacity:0; transform:translateY(-6px); }
  to   { opacity:1; transform:translateY(0); }
}
.abulk__bar { display:flex; align-items:center; gap:0.65rem; flex-wrap:wrap; background:rgba(var(--admin-rust-rgb), 0.06); border:1.5px solid rgba(var(--admin-rust-rgb), 0.25); border-radius:8px; padding:0.6rem 1rem; animation:slideDown 0.2s ease; }
.abulk__count { font-size:0.82rem; font-weight:700; color:var(--admin-rust); white-space:nowrap; }
.abulk__btn { font-size:0.78rem !important; padding:0.4rem 0.8rem !important; white-space:nowrap; }
`, "",{"version":3,"sources":["webpack://./src/admin/AdminSubscribers.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;EAC7C,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;EACd,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,8BAA8B,mBAAmB,EAAE;AACnD,yBAAyB,WAAW,EAAE,+BAA+B,EAAE;AACvE,wBAAwB,kCAAkC,EAAE;;AAE5D,gBAAgB;AAChB;EACE,aAAa,EAAE,mBAAmB,EAAE,WAAW;EAC/C,sBAAsB,EAAE,qCAAqC;EAC7D,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB;EACxD,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;AAChE;;AAEA,2FAA2F;AAC3F;EACE,aAAa,EAAE,mBAAmB,EAAE,WAAW;EAC/C,+BAA+B,EAAE,qCAAqC;EACtE,kBAAkB,EAAE,qBAAqB;EACzC,kBAAkB,EAAE,gBAAgB,EAAE,cAAc;EACpD,+BAA+B;AACjC;AACA;EACE,OAAO,SAAS,EAAE,0BAA0B,EAAE;EAC9C,OAAO,SAAS,EAAE,uBAAuB,EAAE;AAC7C;AACA,cAAc,YAAY,EAAE,kBAAkB,EAAE,WAAW,EAAE,cAAc,EAAE,4CAA4C,EAAE,oDAAoD,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,6BAA6B,EAAE;AACxP,gBAAgB,iBAAiB,EAAE,eAAe,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AACjG,cAAc,4BAA4B,EAAE,gCAAgC,EAAE,kBAAkB,EAAE","sourcesContent":[".asu__stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n}\n.asu__stat-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.asu__stat-top {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n}\n.asu__stat-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.asu__stat-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  margin: 0;\n}\n.asu__stat-value {\n  font-family: var(--font-body);\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n  line-height: 1;\n}\n.asu__stat-change {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin: 0;\n}\n.asu__stat-change.up {\n  color: var(--admin-green);\n}\n.asu__stat-change.down {\n  color: var(--admin-red);\n}\n\n.asu__layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n.asu__layout--detail {\n  grid-template-columns: 1fr 320px;\n  align-items: start;\n}\n\n.asu__filters {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 0.75rem;\n}\n.asu__search-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 180px;\n}\n.asu__search-icon {\n  position: absolute;\n  left: 0.75rem;\n  font-size: 0.9rem;\n  color: var(--admin-muted);\n  pointer-events: none;\n}\n.asu__search {\n  width: 100%;\n  padding: 0.6rem 0.9rem 0.6rem 2.25rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  background: #fff;\n  font-size: 0.84rem;\n  color: var(--admin-text);\n  outline: none;\n}\n.asu__search:focus {\n  border-color: var(--admin-rust);\n}\n.asu__date-filter {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 0.9rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  background: #fff;\n  font-size: 0.84rem;\n  color: var(--admin-text);\n  white-space: nowrap;\n  cursor: pointer;\n}\n.asu__filters-right {\n  margin-left: auto;\n}\n\n.asu__table-card {\n  padding: 0;\n  overflow: hidden;\n}\n.asu__table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.asu__table th {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--admin-muted);\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n  text-align: left;\n  background: #fafaf8;\n}\n.asu__table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f0ebe4;\n  vertical-align: middle;\n}\n.asu__table tbody tr:last-child td {\n  border-bottom: none;\n}\n.asu__th-check {\n  width: 2.5rem;\n}\n.asu__email-cell {\n  font-size: 0.84rem;\n  font-weight: 500;\n  color: var(--admin-text);\n}\n.asu__source-row {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.82rem;\n  color: var(--admin-text);\n}\n\n.asu__badge--active {\n  background: rgba(22, 163, 74, 0.1);\n  color: var(--admin-green);\n  border-radius: 99px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 0.2rem 0.6rem;\n}\n.asu__badge--unsub {\n  background: rgba(107, 98, 88, 0.1);\n  color: var(--admin-muted);\n  border-radius: 99px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 0.2rem 0.6rem;\n}\n\n/* Detail */\n.asu__detail {\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n  overflow: hidden;\n  position: sticky;\n  top: calc(var(--admin-topbar-h)+1rem);\n}\n.asu__detail-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  border-bottom: 1px solid var(--admin-border);\n}\n.asu__detail-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n.asu__detail-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  color: var(--admin-muted);\n  padding: 0.2rem;\n  border-radius: 4px;\n}\n.asu__detail-close:hover {\n  background: #f3f4f0;\n}\n.asu__detail-user {\n  display: flex;\n  gap: 0.85rem;\n  padding: 1rem;\n  align-items: flex-start;\n}\n.asu__detail-avatar {\n  width: 2.6rem;\n  height: 2.6rem;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.asu__detail-name {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.15rem;\n}\n.asu__detail-email {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.4rem;\n}\n.asu__detail-info {\n  padding: 0 1rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n}\n.asu__detail-info-text {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.75rem;\n}\n.asu__detail-source {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.asu__detail-source-label {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n}\n.asu__source-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  background: rgba(var(--admin-rust-rgb), 0.08);\n  color: var(--admin-rust);\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.2rem 0.65rem;\n  border-radius: 99px;\n}\n.asu__detail-section {\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n}\n.asu__detail-section:last-child {\n  border-bottom: none;\n}\n.asu__detail-section-title {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.65rem;\n}\n.asu__activity-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  padding: 0.4rem 0;\n}\n.asu__activity-icon {\n  width: 1.8rem;\n  height: 1.8rem;\n  background: rgba(var(--admin-rust-rgb), 0.08);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  color: var(--admin-rust);\n  flex-shrink: 0;\n}\n.asu__activity-label {\n  font-size: 0.78rem;\n  font-weight: 500;\n  color: var(--admin-text);\n  margin: 0;\n}\n.asu__activity-time {\n  font-size: 0.7rem;\n  color: var(--admin-muted);\n  margin: 0;\n}\n.asu__action-full {\n  width: 100%;\n  margin-bottom: 0.5rem;\n}\n.asu__unsub-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.65rem;\n  border: 1px solid var(--admin-rust);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--admin-rust);\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n  transition: background 0.15s;\n}\n.asu__unsub-btn:hover {\n  background: rgba(var(--admin-rust-rgb), 0.06);\n}\n.asu__delete-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.65rem;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--admin-red);\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n  transition: background 0.15s;\n}\n.asu__delete-btn:hover {\n  background: rgba(220, 38, 38, 0.06);\n}\n.asu__delete-warn {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  margin: 0;\n  background: #faf7f2;\n  border-radius: 6px;\n  padding: 0.6rem 0.75rem;\n}\n\n@media (max-width: 1199px) {\n  .asu__stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .asu__layout--detail {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 767px) {\n  .asu__stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Row context menu */\n.asu__row-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.12);\n  z-index: 50;\n  min-width: 160px;\n  overflow: hidden;\n}\n.asu__row-menu button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.6rem 0.9rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.82rem;\n  color: var(--admin-text);\n  text-align: left;\n  transition: background 0.12s;\n}\n.asu__row-menu button:hover { background: #f9f7f3; }\n.asu__row-menu-divider { height: 1px; background: var(--admin-border); }\n.asu__row-menu-delete { color: var(--admin-red) !important; }\n\n/* Date filter */\n.asu__date-filter {\n  display: flex; align-items: center; gap: 0.5rem;\n  padding: 0.6rem 0.9rem; border: 1px solid var(--admin-border);\n  border-radius: 8px; background: #fff; font-size: 0.84rem;\n  color: var(--admin-text); cursor: pointer; white-space: nowrap;\n}\n\n/* toast + bulk bar (also defined in AdminApplications.css — import from there if shared) */\n.ann__toast {\n  display: flex; align-items: center; gap: 0.5rem;\n  background: rgba(22,163,74,0.1); border: 1px solid rgba(22,163,74,0.3);\n  border-radius: 8px; padding: 0.65rem 1rem;\n  font-size: 0.84rem; font-weight: 600; color: #16a34a;\n  animation: slideDown 0.25s ease;\n}\n@keyframes slideDown {\n  from { opacity:0; transform:translateY(-6px); }\n  to   { opacity:1; transform:translateY(0); }\n}\n.abulk__bar { display:flex; align-items:center; gap:0.65rem; flex-wrap:wrap; background:rgba(var(--admin-rust-rgb), 0.06); border:1.5px solid rgba(var(--admin-rust-rgb), 0.25); border-radius:8px; padding:0.6rem 1rem; animation:slideDown 0.2s ease; }\n.abulk__count { font-size:0.82rem; font-weight:700; color:var(--admin-rust); white-space:nowrap; }\n.abulk__btn { font-size:0.78rem !important; padding:0.4rem 0.8rem !important; white-space:nowrap; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
